import {
  IconChat,
  IconDoc,
  IconFlag,
  IconMessageAlert,
  IconQuestionCircle,
  IconStep,
  IconWorkflow,
} from '@bitrise/bitkit-v2';
import { Separator } from '@chakra-ui/react/separator';
import { Text } from '@chakra-ui/react/text';
import { ReactNode } from 'react';

import URLs from '@/enums/urls';

import LinkItem from './LinkItem';

const HelpDrawer = ({ children }: { children?: ReactNode }) => {
  return children ? (
    children
  ) : (
    <>
      <LinkItem icon={IconQuestionCircle} isExternal href={URLs.SUPPORT_CENTER} title="Support center">
        Support Center
      </LinkItem>
      <Separator marginY="24" />
      <Text textStyle="heading/h6" color="text/tertiary" paddingX="24" marginBottom="16">
        Learn more
      </Text>
      <LinkItem icon={IconDoc} isExternal href={URLs.DOCUMENTATION} title="Answers to your questions">
        Documentation
      </LinkItem>
      <LinkItem icon={IconFlag} isExternal href={URLs.ROADMAP} title="Explore and upvote upcoming features">
        Roadmap
      </LinkItem>
      <LinkItem icon={IconChat} isExternal href={URLs.COMMUNITY_FORUM} title="Ask your fellow developers">
        Community forum
      </LinkItem>
      <LinkItem icon={IconMessageAlert} isExternal href={URLs.BLOG_PRODUCT_UPDATES}>
        News and updates
      </LinkItem>
      <Separator marginY="24" />
      <Text textStyle="heading/h6" color="text/tertiary" paddingX="24" marginBottom="16">
        Resources
      </Text>
      <LinkItem icon={IconStep} isExternal href={URLs.INTEGRATIONS}>
        Step library
      </LinkItem>
      <LinkItem icon={IconWorkflow} isExternal href={URLs.WORKFLOW_RECIPES}>
        Workflow Recipes
      </LinkItem>
    </>
  );
};

export default HelpDrawer;
